export default "__VITE_ASSET__DOeNWrPP__"